import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { useEffect } from 'react';
import { useNavigator } from '../../../routing/navigator';
import { locationStore } from '../../stores/location-store';
import {
  GetLocationInputParams,
  LocationSearchParams,
} from '../../types/input-param-types';
import { Location } from '../../types/server-types';
import { showPrivateToast } from '../../utils/show-private-toast';
import { http } from '../http';
import { CacheKeys } from './cache-configuration';

export const useLocation = (
  params: GetLocationInputParams,
): UseQueryResult<Location> => {
  const navigator = useNavigator();
  const result = useQuery<Location>({
    queryKey: [CacheKeys.LOCATION, params],
    queryFn: () => http.getLocation(params),
  });

  useEffect(() => {
    const error = result.error as any;
    if (error?.request?.status === 404) {
      locationStore.reset();
      navigator.toLanding();
      showPrivateToast('Location no longer exist, please try again');
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [result.error]);

  return result;
};

export const useLocations = (
  params?: LocationSearchParams,
): UseQueryResult<Location[]> => {
  return useQuery({
    queryKey: [CacheKeys.LOCATIONS, params ? params.term : ''],
    queryFn: () => http.getLocations(params),
  });
};
